module.exports = __webpack_public_path__ + "static/img/banner_red.6966bd76.png";